'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIDialogHeader;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UIDialogHeader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      use = _ref.use,
      rest = _objectWithoutProperties(_ref, ['children', 'className', 'use']);

  return _react2.default.createElement(
    'header',
    _extends({}, rest, {
      className: (0, _classnames2.default)('private-modal__header', 'uiDialogHeader', className, { 'private-modal__header--with-toolbar': use === 'toolbar' })
    }),
    _react2.default.createElement(
      'div',
      { className: 'private-modal__header__inner' },
      children
    )
  );
}

UIDialogHeader.propTypes = {
  children: _propTypes2.default.node,
  use: _propTypes2.default.oneOf(['default', 'toolbar'])
};

UIDialogHeader.displayName = 'UIDialogHeader';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/dialog/UIDialogHeader.js
// module id = 553
// module chunks = 177